// weight/style + locale/format/foundry subset tokens that decorate a family name across files;
// dropped as whole segments (between separators / camelCase humps) so a required font name reduces
// to its bare family for a Google-catalog lookup — "AvenirNextCyr-Bold" → "avenirnext".
const WEIGHT_STYLE_TOKENS = new Set([
  'thin',
  'extralight',
  'ultralight',
  'light',
  'regular',
  'normal',
  'book',
  'medium',
  'semibold',
  'demibold',
  'bold',
  'extrabold',
  'ultrabold',
  'black',
  'heavy',
  'italic',
  'oblique',
  // camelCase splits "SemiBold" → "Semi"+"Bold" etc., so the weight prefixes must strip on their own too
  'semi',
  'demi',
  'extra',
  'ultra',
]);
const SUBSET_TOKENS = new Set(['cyr', 'cyrillic', 'cyrl', 'latin', 'pro', 'std', 'mt', 'lt', 'web', 'subset', 'osf']);

function familyTokens(name: string): string[] {
  return name
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .split(/[\s_-]+/)
    .map(segment => segment.toLowerCase())
    .filter(segment => segment.length > 0 && !WEIGHT_STYLE_TOKENS.has(segment) && !SUBSET_TOKENS.has(segment));
}

/** The bare family words for a Google-catalog query — "Roboto-Bold" → "roboto", "AvenirNextCyr" → "avenir next". */
export function familyQuery(name: string): string {
  return familyTokens(name).join(' ');
}

/** A separatorless, lowercase family key for comparing a required name against a catalog candidate. */
export function normFamily(name: string): string {
  return familyTokens(name).join('');
}

/** True when the text uses any Cyrillic letter — a Google substitute must then cover Cyrillic. */
export function hasCyrillicText(text: string | undefined): boolean {
  return !!text && /[Ѐ-ӿ]/.test(text);
}
